import { Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import PI from 'react-phone-input-2';
import 'react-phone-input-2/lib/high-res.css';

// Use the workaround for the import
const ReactPhoneInput = PI.default ? PI.default : PI;

/**
 * @typedef {Object} PhoneInputProps
 * @property {string} value
 * @property {() => void} handleChangeNumber
 * @property {() => void} handleBlur
 * @param {PhoneInputProps & import('react-phone-input-2').PhoneInputProps} props
 * @returns JSX.Element
 * */
function CustomPhoneInput({ value, handleChangeNumber, handleBlur, ...props }) {
    const onlyCountries = useSelector(
        (state) => state.service?.tpm?.countries,
    ) || ['au', 'us', 'gb']; // NOTE: guard for undefined countries case

    return (
        <Box>
            <ReactPhoneInput
                country="gb"
                onlyCountries={onlyCountries}
                enableAreaCodeStretch
                enableLongNumbers={19}
                value={value}
                onChange={handleChangeNumber}
                onBlur={handleBlur}
                {...props}
            />
        </Box>
    );
}

export default CustomPhoneInput;
